<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';
import EmbroideredClothingForm from '@/Components/EmbroideredClothingForm.vue';
</script>

<template>
    <AppLayout title="Modification de la demande de devis">
        <EmbroideredClothingForm />
    </AppLayout>
</template>
